import { apply, put, select } from 'redux-saga/effects';
import {
  onLoadTestsSucceeded,
  onLoadTestSucceeded,
  onSubmitTestSucceeded,
  onLoadResultsSucceeded,
  onStartTestSucceeded,
  onLoadExamsFaild,
  onLoadExamsSucceeded,
  selectExam,
  loadSingleQuestionSucceeded,
  loadSingleQuestionFailed,
} from '../reducers/test.reducers';

import {
  errorNotification,
  successNotification,
} from '../reducers/notification.reducers';

export function* loadTests(testApi) {
  const response = yield apply(testApi, testApi.loadTestsAndGroups);
  if (response.errorCode) {
    yield put(errorNotification('Fehler beim Laden der Tests'));
  } else {
    yield put(onLoadTestsSucceeded({ tests: response }));
  }
}

export function* loadAllTestQuestions(testApi, { payload }) {
  try {
    const response = yield apply(testApi, testApi.loadTestQuestions, [
      payload.id,
    ]);

    if (response.error) {
      yield put(errorNotification('Fehler beim Abrufen der Fragen'));
    } else {
      yield put(onLoadTestSucceeded({ questions: response, test: payload }));
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Abrufen der Fragen'));
  }
}

export function* loadTestQuestions(testApi, { payload }) {
  try {
    yield loadTests(testApi);

    const testRuns = yield select((state) => state.tests.testRuns);
    const openRun = testRuns.find((t) => t.testId == payload.id);
    let response = null;
    if (openRun) {
      response = yield apply(testApi, testApi.loadTestRunQuestionsV2, [
        openRun.id,
      ]);
    } else {
      response = yield apply(testApi, testApi.loadTestQuestions, [payload.id]);
    }

    // const response = yield apply(
    //   testApi,
    //   testApi.loadTestQuestions, [payload.id]);

    if (response.error) {
      yield put(errorNotification('Fehler beim Abrufen der Fragen'));
    } else {
      yield put(onLoadTestSucceeded({ questions: response, test: payload }));
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Abrufen der Fragen'));
  }
}

export function* loadExamQuestions(testApi, { payload }) {
  try {
    // yield loadTests(testApi);

    const testRuns = yield select((state) => state.tests.testRuns);
    const openRun = testRuns.find((t) => t.testId == payload.id);
    let response = null;
    if (openRun) {
      response = yield apply(testApi, testApi.loadActiveExamQuestions, [
        openRun.id,
      ]);
    } else {
      response = yield apply(testApi, testApi.loadExamQuestions, [payload.id]);
    }

    // const response = yield apply(
    //   testApi,
    //   testApi.loadTestQuestions, [payload.id]);

    if (response.error) {
      yield put(errorNotification('Fehler beim Abrufen der Fragen'));
    } else {
      yield put(onLoadTestSucceeded({ questions: response, test: payload }));
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Abrufen der Fragen'));
  }
}

export function* loadResults(testApi) {
  try {
    const response = yield apply(testApi, testApi.loadTestRuns);

    if (response.error) {
      yield put(errorNotification('Fehler beim Abrufen der Ergebnisse'));
    } else {
      yield put(onLoadResultsSucceeded({ results: response }));
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Abrufen der Ergebnisse'));
  }
}

export function* loadResultQuestions(testApi, { payload }) {
  try {
    yield loadResults(testApi);
    const response = yield apply(testApi, testApi.loadTestRunQuestions, [
      payload.id,
    ]);

    if (response.error) {
      yield put(errorNotification('Fehler beim Abrufen der Ergebnisse'));
    } else {
      yield put(
        onLoadTestSucceeded({
          questions: response,
          test: payload,
          result: true,
        })
      );
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Abrufen der Ergebnisse'));
  }
}

export function* startTest(testApi, { payload }) {
  try {
    const response = yield apply(testApi, testApi.startTestRun, [payload]);
    yield put(onStartTestSucceeded(response));
  } catch (e) {}
}

export function* submitAnswer(testApi, { payload }) {
  try {
    const { testRunId, question, answersTicked } = payload;
    const tickedAnswerIds = answersTicked ? Object.keys(answersTicked) : [];
    const response = yield apply(testApi, testApi.sendTestRunAction, [
      testRunId,
      { questionId: question.id, tickedAnswerIds },
    ]);
  } catch (e) {}
}

export function* submitTestRun(testApi, { payload }) {
  try {
    const tests = yield select((state) => state.tests);

    const testId = tests.selectedTest.id;

    const answers = Object.keys(tests.answersGiven).map((questionId) => {
      const tickedAnswerIds = tests.answersGiven[questionId].tickedAnswerIds;
      return {
        questionId,
        tickedAnswerIds,
      };
    });

    const testDto = {
      testId,
      startDate: tests.runStartedAt,
      endDate: new Date().toISOString(),
      answers,
    };

    const response = yield apply(testApi, testApi.submitTest, [testDto]);

    if (response.error) {
      yield put(errorNotification('Fehler übermitteln des Tests'));
    } else {
      yield put(onSubmitTestSucceeded());
    }
  } catch (e) {
    yield put(errorNotification('Fehler übermitteln des Tests'));
  }
}

export function* loadExamTests(testApi, { payload }) {
  try {
    const response = yield apply(testApi, testApi.getExamTests);

    if (response.error) {
      yield put(errorNotification('Fehler beim Laden der Prüfungen'));
      yield put(onLoadExamsFaild());
    } else {
      yield put(onLoadExamsSucceeded(response));
      if (payload) {
        yield put(selectExam(payload));
      }
    }
  } catch (e) {
    yield put(errorNotification('Fehler beim Laden der Prüfungen'));
    yield put(onLoadExamsFaild());
  }
}

export function* submitExamAnswer(testApi, { payload }) {
  try {
    const { testRunId, question, answersTicked, examId } = payload;
    const tickedAnswerIds = answersTicked ? Object.keys(answersTicked) : [];
    const response = yield apply(testApi, testApi.sendExamTestRunAction, [
      testRunId,
      examId,
      { questionId: question.id, tickedAnswerIds },
    ]);
  } catch (e) {}
}

export function* loadQuestionById(testApi, { payload }) {
  try {
    const response = yield apply(testApi, testApi.loadQuestion, [payload]);

    if (response.errorCode || !response) {
      yield put(loadSingleQuestionFailed());
    } else {
      yield put(loadSingleQuestionSucceeded(response));
    }
  } catch (e) {
    yield put(
      loadSingleQuestionFailed({
        message: 'Fehler beim Laden des Kärtchens',
      })
    );
  }
}

export function* removeTestRun(testApi, { payload }) {
  try {
    yield apply(testApi, testApi.removeTestRun, [payload]);
  } catch (e) {
    console.log(e);
  }
}



// WEBPACK FOOTER //
// ./src/app/sagas/test.sagas.js